<template>
  <div class="page dark intro">
    <div class="inner">
      <h1>Terms &amp; Conditions</h1>

<p>A deposit will be required to confirm all studio bookings. Such deposit is non-refundable and shall be equal to 25% of the cost of the total time booked. "Copse Corner Music" reserves the right to waive such deposit requirement in its unfettered discretion. Studio bookings for which no deposit has been received by "Copse Corner Music" shall be subject to change or cancellation should management so decide, without notice to client.</p>

<p>Notice of a client's intent to cancel a session must be received by "Copse Corner Music" no later than 7 days before such session. If notice is not received by "Copse Corner Music", the client shall be liable for the cost of one half of the time booked. Client's deposit as stated above will be applied by "Copse Corner Music" in partial satisfaction of such liability. Sessions cancelled the same day of the scheduled session will be liable for the total cost of the booked time.</p>

<p>Payment in full for materials and fees is due and payable immediately following each session. "Copse Corner Music" reserves the right to make other financial arrangements with its clients. Client(s) will pay all Copse Corner Music’s legal fees associated with financial collection processes for services rendered by “Copse Corner Music” or materials purchased.</p>

<p>No recordings in Copse Corner Music’s possession shall be released to clients until all open accounts have been settled and all checks tendered as payment have cleared Copse Corner Music’s account.</p>

<p>Clients assume all risks associated with storing, on or off the premises of Copse Corner Music, or Copse Corner Music’s use of, any and all sound recordings, video recordings, digital data in any storage format including but not limited to audio, video, smpte, midi, or other file types, or equipment of any kind or nature and shall hold "Copse Corner Music" harmless from any and all damage that might occur to said articles for any reason. Copse Corner Music’s liability with respect to "downtime" of any and all studio sessions as a result from equipment malfunction or availability, personnel, hired musicians, acts of nature or public utility companies, etc., shall be limited solely to the studio time of such booked session; and client(s) agree to hold "Copse Corner Music" harmless from any and all damages from such "downtime".</p>

<p>"Copse Corner Music" makes no warranties either express or implied other than those contained herein. "Copse Corner Music" shall not be liable for unforeseen of consequential damages of any kind. Should "Copse Corner Music" be unable to conduct a booked session for any reason, then "Copse Corner Music" warrants that it shall re-book such cancelled booking at another time that is mutually available to "Copse Corner Music" and the client. Rates, policies, and equipment may change without displayed, written or verbal notice.</p>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style scoped lang="scss">
.intro{
  padding-top:80px;
  .inner{
    max-width: 1200px;
    margin:0 auto;
    padding:0 5%;

  }
}

h1{
  margin-bottom:0.6em;
}
@media only screen and (max-width: 800px) {

}
</style>
